import { requestJSON } from '@tv2/lib-core/request';
import { ClientUser } from '@tv2/lib-api/src/ClientUser';

let _currentFetch: Promise<{ user: ClientUser | null } | null> | null = null;

export function fetchUser(): Promise<{ user: ClientUser | null } | null> {
  if (_currentFetch) return _currentFetch;
  const expiration = new Promise(resolve => {
    setTimeout(resolve, 60000);
  });
  _currentFetch = requestJSON<{ user: ClientUser | null }>('/api/user', {
    credentials: 'same-origin',
  })
    .then(r => {
      expiration.then(() => {
        _currentFetch = null;
      });
      return r.data ?? null;
    })
    .catch(() => null);

  return _currentFetch;
}

export function logout() {
  window.location.href = '/api/user/logout';
}
